import posthog from 'posthog-js';

const PROJECT_API_KEY = 'phc_XWyhisVf4l5jRJ70KCOPc5xs268jXFQMeGQykr1PV53';
const API_HOST = 'https://eu.posthog.com';

const initializePostHog = () => {
  const userConsent = localStorage.getItem("userConsent");
  if (userConsent === "accepted") {
    posthog.init(PROJECT_API_KEY, {
      api_host: API_HOST,
      opt_out_capturing_by_default: false
    });
  } else {
    posthog.init(PROJECT_API_KEY, {
      api_host: API_HOST,
      opt_out_capturing_by_default: true
    });
    posthog.opt_out_capturing(); 
  }
};

export default initializePostHog;